import React from "react";
import { MapPin, Phone, Mail, Facebook, Twitter, Instagram, Send } from "react-feather";

const Contact = () => {
  return (
    <main className="bg-white text-gray-800">
      {/* HERO SECTION */}
      <section className="relative bg-[#0F2D52] text-white py-16 sm:py-24 text-center overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-[#0F2D52] to-[#081a30] opacity-95"></div>
        <div className="relative z-10 max-w-3xl mx-auto px-4 sm:px-6">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 sm:mb-6">Get in Touch</h1>
          <p className="text-base sm:text-lg opacity-90 leading-relaxed">
            Whether you’re an NRI looking for reliable home assistance or just curious about our services, we’re always happy to help.
          </p>
        </div>
      </section>

      {/* CONTACT SECTION */}
      <section className="py-12 sm:py-20 container mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-10 lg:gap-16 items-start">
        {/* Contact Info */}
        <div className="space-y-6 sm:space-y-10">
          <div>
            <h2 className="text-2xl sm:text-3xl font-bold text-[#0F2D52] mb-3">Our Office</h2>
            <p className="text-gray-600 leading-relaxed text-sm sm:text-base">
              NRI Local Buddy is headquartered in Hyderabad, India. Reach out to us for any inquiries or service requests. We ensure a prompt response.
            </p>
          </div>

          <div className="space-y-4 sm:space-y-6 text-sm sm:text-base">
            <div className="flex items-center space-x-4">
              <Phone className="text-[#C89B3C] flex-shrink-0" />
              <a href="https://wa.me/919618222498" className="hover:text-[#ab812f] transition">
                +91 9618222498
              </a>
            </div>
            <div className="flex items-center space-x-4">
              <Mail className="text-[#C89B3C] flex-shrink-0" />
              <a href="mailto:hello@ay-technologies.com" className="hover:text-[#ab812f] transition break-all">
                hello@ay-technologies.com
              </a>
            </div>
            <div className="flex items-start space-x-4">
              <MapPin className="text-[#C89B3C] mt-1 flex-shrink-0" />
              <p>112, Telkar Chambers, Tara Nagar, Chanda Nagar, Hyderabad, Telangana 500019, India</p>
            </div>
          </div>

          <div className="flex space-x-6 pt-4 sm:pt-6">
            <a href="https://www.facebook.com/nrilocalbuddy/" className="text-[#0F2D52] hover:text-[#C89B3C]">
              <Facebook />
            </a>
          </div>
        </div>

        {/* Contact Form */}
        <form className="bg-gray-50 p-6 sm:p-8 lg:p-10 rounded-2xl shadow-md space-y-4 sm:space-y-6">
          <h2 className="text-2xl sm:text-3xl font-semibold text-[#0F2D52] mb-2 sm:mb-4">Send Us a Message</h2>

          <div>
            <label className="block font-semibold mb-2 text-sm sm:text-base">Full Name</label>
            <input
              type="text"
              placeholder="Enter your full name"
              className="w-full border border-gray-300 rounded-xl px-4 sm:px-5 py-3 sm:py-4 focus:ring-2 focus:ring-[#0F2D52] outline-none text-sm sm:text-base"
            />
          </div>

          <div>
            <label className="block font-semibold mb-2 text-sm sm:text-base">Email Address</label>
            <input
              type="email"
              placeholder="Enter your email"
              className="w-full border border-gray-300 rounded-xl px-4 sm:px-5 py-3 sm:py-4 focus:ring-2 focus:ring-[#0F2D52] outline-none text-sm sm:text-base"
            />
          </div>

          <div>
            <label className="block font-semibold mb-2 text-sm sm:text-base">Subject</label>
            <input
              type="text"
              placeholder="Subject of your message"
              className="w-full border border-gray-300 rounded-xl px-4 sm:px-5 py-3 sm:py-4 focus:ring-2 focus:ring-[#0F2D52] outline-none text-sm sm:text-base"
            />
          </div>

          <div>
            <label className="block font-semibold mb-2 text-sm sm:text-base">Message</label>
            <textarea
              rows="5"
              placeholder="Write your message here..."
              className="w-full border border-gray-300 rounded-xl px-4 sm:px-5 py-3 sm:py-4 focus:ring-2 focus:ring-[#0F2D52] outline-none text-sm sm:text-base"
            ></textarea>
          </div>

          <button
            type="submit"
            className="w-full bg-[#C89B3C] text-white font-semibold py-3.5 sm:py-4 rounded-xl hover:bg-[#ab812f] flex items-center justify-center gap-2 transition-all duration-300 text-sm sm:text-base"
          >
            <Send className="w-5 h-5" /> Send Message
          </button>
        </form>
      </section>

      {/* MAP SECTION */}
      <section className="h-[400px] mt-10">
        <iframe
          title="NRI Local Buddy Location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3807.500736527495!2d78.31940337512091!3d17.38974568348073!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb93f2b5a5cbcb%3A0x9b3f586f2c3a1b4a!2sChanda%20Nagar%2C%20Hyderabad%2C%20Telangana%20500050!5e0!3m2!1sen!2sin!4v1730475281234!5m2!1sen!2sin"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          className="rounded-t-2xl"
        ></iframe>
      </section>

      {/* CTA BANNER */}
      <section className="bg-[#0F2D52] text-white py-16 text-center">
        <h2 className="text-3xl font-bold mb-4">We’re Here for You</h2>
        <p className="text-lg mb-8 opacity-90">
          Have a special request? Chat with our local team or book a callback.
        </p>
        <a
          href="https://wa.me/919618222498"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center px-8 py-4 bg-[#C89B3C] rounded-full text-white font-semibold hover:bg-[#ab812f] transition-all duration-300 shadow-lg hover:shadow-xl"
        >
          Chat on WhatsApp
        </a>
      </section>
    </main>
  );
};

export default Contact;
